@if (visible) {
  <div [ngClass]="cssClassName">
    <h1>{{title}}</h1>
    @if (!!text) {
      <p markdown>{{ text }}</p>
    }
  </div>
}
